import request from './request';




// 索样 留言

export function MemberConsultation_add(data) {
    return request({
        url: `/pc/MemberConsultation/add`,
        method: 'post',
        data
    })
}


//产品列表
export function product_lists(params) {
    return request({
        url:'/pc/product/lists',
        method: 'get',
        params
    })
}
//产品分类
export function categoryLists(params) {
    return request({
        url:'/pc/product/categoryLists',
        method: 'get',
        params
    })
}
//产品详情
export function product_detail(params) {
    return request({
        url:'/pc/product/detail',
        method: 'get',
        params
    })
}



